import {httpClient} from './httpClient';

const END_POINT = '/categories/';

const getAllCategories = (params = {}) => httpClient.get(END_POINT, { params });

export {
    getAllCategories
}
